import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { CityService } from './city.service';

const service = new CityService();

export interface CityState {}

const CityStore: Module<CityState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async searchCities(context, query?: LocationQuery) {
         const response = await service.getCities(query);
         return response.data;
      },
   },
};

export default CityStore;
